import { organizationIdSchema } from "@estate-platform/domain/ids";
import { createFileRoute, getRouteApi } from "@tanstack/react-router";

import { useViewer } from "../data/hooks.ts";
import { loadOrganization } from "../people/loaders.ts";
import { OrganizationPage } from "../people/organization-page.tsx";
import { peopleTabsFor } from "../people/permissions.ts";
import { RecordPending } from "../shell/record-pending.tsx";
import { parameterOrNotFound } from "../shell/route-parameters.ts";
import { NoAccessPage } from "../shell/status-pages.tsx";

import type { ReactElement } from "react";

const route = getRouteApi("/_app/organizations/$id");

const Page = (): ReactElement => {
  const viewer = useViewer();
  const { id } = route.useParams();
  return viewer === null || peopleTabsFor(viewer).length === 0 ? (
    <NoAccessPage />
  ) : (
    <OrganizationPage viewer={viewer} organizationId={id} />
  );
};

export const Route = createFileRoute("/_app/organizations/$id")({
  params: {
    parse: ({ id }) => ({ id: parameterOrNotFound(organizationIdSchema, id) }),
    stringify: ({ id }) => ({ id }),
  },
  loader: async ({ context, params }) => loadOrganization(context.data, params.id),
  pendingComponent: () => <RecordPending lead="square" />,
  component: Page,
});
